module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "stars"
  }, [_vm._l((_vm.fullStar), function(i) {
    return _c('span', [_c('img', {
      attrs: {
        "src": require("../../static/components/stars/star_full.png")
      },
      on: {
        "click": function($event) {
          return _vm.clickFull(i)
        }
      }
    })])
  }), _vm._v(" "), (_vm.hasHalfStar) ? _c('span', [_c('img', {
    attrs: {
      "src": require("../../static/components/stars/star_half.png")
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.nullStar), function(i) {
    return _c('span', [_c('img', {
      attrs: {
        "src": require("../../static/components/stars/star_empty.png")
      },
      on: {
        "click": function($event) {
          return _vm.clickEmpty(i)
        }
      }
    })])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-be4ac4ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stars.vue
// module id = 1586
// module chunks = 18